import { expVal } from '@townsquare/stat-sig';

export const RECENTS_TAB_QUERY_PARAM = 'tab';

export type RecentsTab = 'viewed' | 'workedOn';

export const WORKED_ON_TAB = 'workedOn';
export const VIEWED_TAB = 'viewed';

export const isRecentsTab = (value?: string | null): value is RecentsTab =>
	value === WORKED_ON_TAB || value === VIEWED_TAB;

export const parseRecentsTab = (param?: string | null): RecentsTab => {
	if (isRecentsTab(param)) {
		return param;
	} else if (expVal('townsquare_exp_viewed_as_default', 'isEnabled', false)) {
		return VIEWED_TAB;
	} else {
		return WORKED_ON_TAB;
	}
};
